import React, { useRef, useEffect, useState } from 'react';
import './ListingDetailModal.css';
import { Map, Marker, useMap, useMapsLibrary } from '@vis.gl/react-google-maps';

// --- Icons ---
const CloseIcon = () => (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>);
const WarningIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#D32F2F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>);
const CarIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>);
const SunIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d4a017" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line></svg>);
const SchoolIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2a2a33" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 12h20"></path><path d="M7 2v10"></path><path d="M17 2v10"></path><path d="M2 22h20"></path><path d="M12 2v20"></path></svg>);
const ShareIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line></svg>);

// New Investor Icons
const LightbulbIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#F57F17" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18h6"></path><path d="M10 22h4"></path><path d="M12 2a7 7 0 0 1 7 7c0 2.38-1.19 4.47-3 5.74V17a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2v-2.26C6.19 13.47 5 11.38 5 9a7 7 0 0 1 7-7z"></path></svg>);
const BuildingIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#006aff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect><line x1="9" y1="22" x2="9" y2="22.01"></line><line x1="15" y1="22" x2="15" y2="22.01"></line><line x1="12" y1="22" x2="12" y2="22.01"></line><line x1="12" y1="2" x2="12" y2="6"></line><line x1="8" y1="6" x2="16" y2="6"></line></svg>);
const DollarIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#388E3C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg>);
const CraneIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 22h16"></path><path d="M14 2L9 22"></path><path d="M10 6l4-4 8 4-8 4"></path></svg>);
const AnchorIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1976D2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="5" r="3"></circle><line x1="12" y1="22" x2="12" y2="8"></line><path d="M5 12H2a10 10 0 0 0 20 0h-3"></path></svg>);
const ChartIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#388E3C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line></svg>);
const ShieldIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>);


// --- Types ---
interface ImpactItem {
  icon: 'noise' | 'traffic' | 'shadow' | 'school' | 'parking' | 'privacy' | 'construction' | 'visual' | 'supply' | 'retail' | 'rent' | 'assemblage' | 'stability' | 'commercial' | 'arv' | 'neighborhood';
  title: string;
  desc: string;
  level: 'CRITICAL' | 'HIGH' | 'MODERATE' | 'LOW' | 'MEDIUM' | 'MINIMAL' | 'ACTIVE' | 'POSITIVE' | 'NEUTRAL';
}

interface TimelineEvent {
  date: string;
  title: string;
  active: boolean;
}

interface DeepData {
  signal?: string; // New Investment Signal
  overview: string;
  impacts: ImpactItem[];
  facts: { [key: string]: string };
  timeline: TimelineEvent[];
}

interface DetailProps {
  listing: any;
  onClose: () => void;
  viewMode: string;
}

// --- BUYER DATA PAYLOADS ---
const BUYER_DATA_MAP: { [key: number]: DeepData } = {
  1: { // The Pointe at Main
    overview: "Developer Famco LLC proposes a major redevelopment of the existing retail strip into a 6-story mixed-use complex. Plan includes demolition of current structures, construction of 220 market-rate residential units, and 6,000 sq ft of ground-floor retail.",
    impacts: [
      { icon: 'noise', title: "Noise", desc: "Geotech report confirms shallow bedrock at 15ft. Pneumatic hammering required for foundation (est. 3-4 months).", level: 'CRITICAL' },
      { icon: 'traffic', title: "Traffic", desc: "108 new PM Peak trips projected. Driveway restricted to Right-In/Right-Out (No Left Turn on Main St).", level: 'MODERATE' },
      { icon: 'shadow', title: "Shadow", desc: "6-Story height (65ft) will shade northern properties on Portland Ave after 3 PM.", level: 'HIGH' },
      { icon: 'school', title: "Schools", desc: "Projected +18 Students (Bergenfield High & Hoover Elementary) based on 1-bedroom unit mix.", level: 'LOW' }
    ],
    facts: {
      "Developer": "Famco, LLC & New West Properties",
      "Units": "220 Residential",
      "Parking": "313 Spaces (Structured Garage)",
      "Lot Size": "1.99 Acres",
      "Zoning": "Area 'D' Redevelopment Zone",
      "Impervious Coverage": "84% (Decreased from existing)"
    },
    timeline: [
      { date: "Nov 17, 2025", title: "Planning Board Public Hearing", active: true },
      { date: "Nov 06, 2025", title: "Traffic Study Revised", active: false },
      { date: "May 03, 2024", title: "Geotechnical Investigation (Bedrock Found)", active: false }
    ]
  },
  2: { // Muslim Cultural Center
    overview: "Application for site plan approval to construct an addition to the existing House of Worship. The project aims to expand facility capacity for community services and religious gatherings.",
    impacts: [
      { icon: 'parking', title: "Parking", desc: "Expansion implies increased visitor capacity. Buyers on Johnson Ave should monitor street parking availability during service hours.", level: 'MEDIUM' },
      { icon: 'traffic', title: "Traffic", desc: "Intermittent traffic pulses expected during scheduled events/services.", level: 'LOW' }
    ],
    facts: {
      "Applicant": "Muslim Cultural Center (Owner)",
      "Use Group": "Institutional / Civic",
      "Zoning": "Residential (Conditional Use)",
      "Scope": "Building Addition",
      "Variances": "None listed in agenda"
    },
    timeline: [
      { date: "Nov 03, 2025", title: "Zoning Board Vote (Old Business)", active: true },
      { date: "Oct 20, 2025", title: "Previous Hearing", active: false }
    ]
  },
  3: { // Rubin Garage
    overview: "Homeowner seeks Bulk Variance approval to construct a new addition and a one-car garage. The proposal requires relief from standard zoning setback requirements.",
    impacts: [
      { icon: 'privacy', title: "Privacy", desc: "Structure may be built closer to the property line than standard code allows.", level: 'LOW' },
      { icon: 'noise', title: "Noise", desc: "Standard residential renovation noise (approx. 2-4 weeks).", level: 'MINIMAL' }
    ],
    facts: {
      "Owner": "Marc Rubin",
      "Zoning": "Single Family Residential",
      "Variance": "Bulk Variance (Side/Front Yard)",
      "Lot": "Block 126, Lot 9"
    },
    timeline: [
      { date: "Nov 03, 2025", title: "Application Filed (Zoning Board)", active: true }
    ]
  },
  4: { // Gutwein Home
    overview: "Finalization of approval for a residential addition and alteration. The Board is voting to memorialize the resolution, signaling that construction permits can now be issued.",
    impacts: [
      { icon: 'construction', title: "Construction", desc: "Approval finalized. Expect construction crews and renovation noise to begin immediately.", level: 'ACTIVE' }
    ],
    facts: {
      "Owner": "Marina & Andrew Gutwein",
      "Zoning": "Single Family Residential",
      "Status": "Resolution Memorialization",
      "Scope": "Addition & Alteration"
    },
    timeline: [
      { date: "Nov 03, 2025", title: "Resolution Memorialization (Final Step)", active: true },
      { date: "Oct 20, 2025", title: "Application Approved", active: false }
    ]
  },
  5: { // Isser Home
    overview: "Proposed addition and alteration to an existing single-family residence. Requires Zoning Board review for bulk variances.",
    impacts: [
      { icon: 'visual', title: "Visual", desc: "Potential change to building footprint/height pending variance details.", level: 'LOW' }
    ],
    facts: {
      "Owner": "Jonathan Isser",
      "Zoning": "Single Family Residential",
      "Scope": "Addition/Alteration"
    },
    timeline: [
      { date: "Nov 03, 2025", title: "Application Filed (Zoning Board)", active: true }
    ]
  }
};

// --- INVESTOR DATA PAYLOADS ---
const INVESTOR_DATA_MAP: { [key: number]: DeepData } = {
  1: { // The Pointe at Main
    signal: "MARKET CATALYST",
    overview: "Class-A mixed-use development adding 220 market-rate units to the downtown corridor. This project serves as a major supply anchor, likely lifting price ceilings for surrounding vintage inventory.",
    impacts: [
      { icon: 'supply', title: "Supply Shock", desc: "Introduction of 220 units validates local density demand. Will create new 'Comparable' highs for the zip code.", level: 'POSITIVE' },
      { icon: 'retail', title: "Retail Anchor", desc: "6,000 sq ft commercial space increases 'Walk Score' and desirability for 2-block radius.", level: 'POSITIVE' },
      { icon: 'rent', title: "Rent Premium", desc: "Projected rents estimated at 15-20% above area average ($2,100). Good signal for value-add renovation plays nearby.", level: 'POSITIVE' },
      { icon: 'assemblage', title: "Assemblage Play", desc: "Adjacent lots are currently zoned R-1. Successful approval here signals strong potential for future upzoning of neighbors.", level: 'POSITIVE' }
    ],
    facts: {
      "Developer": "Famco, LLC & New West Properties",
      "Density": "110 Units/Acre (High Yield)",
      "Asset Class": "Mixed-Use / Mid-Rise",
      "Parking": "Structured (Premium Amenity)",
      "Market Position": "Class A / Luxury"
    },
    timeline: [
      { date: "Nov 17, 2025", title: "Planning Board Hearing", active: true },
      { date: "Spring 2026", title: "Est. Break Ground", active: false },
      { date: "Q4 2027", title: "Est. Lease Up", active: false }
    ]
  },
  2: { // Muslim Cultural Center
    signal: "CIVIC ANCHOR",
    overview: "Expansion of a key community institution. Large capital investment into the existing facility indicates long-term commitment to the neighborhood.",
    impacts: [
      { icon: 'stability', title: "Stability", desc: "Institutional anchors reduce vacancy risk in adjacent residential units due to 'sticky' local demographic.", level: 'POSITIVE' },
      { icon: 'commercial', title: "Commercial Impact", desc: "Neutral/Positive. Brings consistent foot traffic to the area outside of standard business hours.", level: 'NEUTRAL' }
    ],
    facts: {
      "Type": "Institutional Expansion",
      "Owner User": "Yes",
      "Neighborhood": "Eastern Residential Zone"
    },
    timeline: [
      { date: "Nov 03, 2025", title: "Zoning Board Decision", active: true }
    ]
  },
  // IDs 3, 4, 5 share the "Residential Investment Activity" payload pattern
  3: {
    signal: "EQUITY ACTIVITY",
    overview: "Cluster of homeowner-driven capital improvements (Additions/Garages). High volume of permits in this quadrant signals rising equity and owner confidence.",
    impacts: [
      { icon: 'arv', title: "ARV Signal", desc: "Multiple variance applications for expansion indicate property values support higher investment. Good territory for Fix-and-Flip.", level: 'POSITIVE' },
      { icon: 'neighborhood', title: "Neighborhood Grade", desc: "Improving. Active reinvestment into housing stock prevents blight.", level: 'POSITIVE' }
    ],
    facts: {
      "Activity Type": "Renovation / Expansion",
      "Volume": "3 Active Applications in Nov 2025",
      "Zoning": "R-1 (Single Family)"
    },
    timeline: [
      { date: "Nov 2025", title: "Active Board Review", active: true }
    ]
  },
  4: {
    signal: "EQUITY ACTIVITY",
    overview: "Cluster of homeowner-driven capital improvements (Additions/Garages). High volume of permits in this quadrant signals rising equity and owner confidence.",
    impacts: [
      { icon: 'arv', title: "ARV Signal", desc: "Multiple variance applications for expansion indicate property values support higher investment. Good territory for Fix-and-Flip.", level: 'POSITIVE' },
      { icon: 'neighborhood', title: "Neighborhood Grade", desc: "Improving. Active reinvestment into housing stock prevents blight.", level: 'POSITIVE' }
    ],
    facts: {
      "Activity Type": "Renovation / Expansion",
      "Volume": "3 Active Applications in Nov 2025",
      "Zoning": "R-1 (Single Family)"
    },
    timeline: [
      { date: "Nov 2025", title: "Active Board Review", active: true }
    ]
  },
  5: {
    signal: "EQUITY ACTIVITY",
    overview: "Cluster of homeowner-driven capital improvements (Additions/Garages). High volume of permits in this quadrant signals rising equity and owner confidence.",
    impacts: [
      { icon: 'arv', title: "ARV Signal", desc: "Multiple variance applications for expansion indicate property values support higher investment. Good territory for Fix-and-Flip.", level: 'POSITIVE' },
      { icon: 'neighborhood', title: "Neighborhood Grade", desc: "Improving. Active reinvestment into housing stock prevents blight.", level: 'POSITIVE' }
    ],
    facts: {
      "Activity Type": "Renovation / Expansion",
      "Volume": "3 Active Applications in Nov 2025",
      "Zoning": "R-1 (Single Family)"
    },
    timeline: [
      { date: "Nov 2025", title: "Active Board Review", active: true }
    ]
  }
};

// Helper: Get Icon Component based on string
const getIcon = (type: string) => {
  switch(type) {
    // Buyer Icons
    case 'noise': return <WarningIcon />; 
    case 'traffic': case 'parking': return <CarIcon />;
    case 'shadow': return <SunIcon />;
    case 'school': return <SchoolIcon />;
    case 'construction': return <WarningIcon />; 
    case 'privacy': return <ShieldIcon />;
    case 'visual': return <CraneIcon />;
    // Investor Icons
    case 'supply': return <LightbulbIcon />;
    case 'retail': return <BuildingIcon />;
    case 'rent': return <DollarIcon />;
    case 'assemblage': return <CraneIcon />;
    case 'stability': return <AnchorIcon />;
    case 'commercial': return <CarIcon />; // Reusing Car for foot traffic/commercial
    case 'arv': return <ChartIcon />;
    case 'neighborhood': return <ShieldIcon />;
    default: return <WarningIcon />;
  }
};

// Helper: Get Color Class based on Level
const getLevelClass = (level: string) => {
  if (level === 'CRITICAL' || level === 'HIGH') return 'status-badge red';
  if (level === 'MODERATE' || level === 'MEDIUM') return 'status-badge yellow';
  if (level === 'ACTIVE' || level === 'POSITIVE') return 'status-badge green';
  return 'status-badge blue'; // Low, Minimal, Neutral
};

// Helper: Get Badge Color for Header
const getBadgeClass = (pinColor: string) => {
  if (pinColor === 'red') return 'status-badge red';
  if (pinColor === 'yellow') return 'status-badge yellow';
  if (pinColor === 'green') return 'status-badge green';
  return 'status-badge blue';
};

// --- Mini Map Circle Component ---
const MiniMapCircle = ({ center, radius, color }: { center: google.maps.LatLngLiteral, radius: number, color: string }) => {
  const map = useMap();
  const circleRef = useRef<google.maps.Circle | null>(null);

  useEffect(() => {
    if (!map) return;
    
    // Clear previous circle if exists
    if (circleRef.current) circleRef.current.setMap(null);

    const circle = new google.maps.Circle({
      strokeColor: color,
      strokeOpacity: 1.0,
      strokeWeight: 1,
      fillColor: color,
      fillOpacity: 0.2, // 20% opacity as requested
      map,
      center,
      radius,
      zIndex: 10,
      clickable: false,
    });

    circleRef.current = circle;
    return () => {
      if (circleRef.current) circleRef.current.setMap(null);
    };
  }, [map, center, radius, color]);

  return null;
};

// --- LIVE STREET VIEW COMPONENT ---
// This attempts to find valid panorama data within 50m.
// If valid data is found, it renders. If not, it triggers the error state.
const StreetViewThumbnail = ({ position }: { position: google.maps.LatLngLiteral }) => {
  const ref = useRef<HTMLDivElement>(null);
  const streetViewLib = useMapsLibrary('streetView');
  const [hasData, setHasData] = useState<boolean | null>(null); // null = loading, true = found, false = not found

  useEffect(() => {
    if (!streetViewLib || !ref.current) return;
    
    const svService = new streetViewLib.StreetViewService();
    
    // 1. Check if panorama data exists nearby (50m radius is standard fallback)
    svService.getPanorama({ location: position, radius: 50 }, (data, status) => {
      if (status === 'OK') {
        setHasData(true);
        // 2. Initialize Panorama only if data found
        new streetViewLib.StreetViewPanorama(ref.current as HTMLElement, {
          position: position, // The API automatically snaps to the found panorama position
          pov: { heading: 0, pitch: 0 },
          zoom: 1,
          disableDefaultUI: true, // Disable UI here as well, plus CSS hides the rest
          clickToGo: false,
          scrollwheel: false,
          showRoadLabels: false,
          motionTracking: false,
          motionTrackingControl: false,
          linksControl: false,
          panControl: false,
          enableCloseButton: false
        });
      } else {
        setHasData(false);
      }
    });
    
  }, [streetViewLib, position]);

  if (hasData === false) {
    return (
      <div style={{width:'100%', height:'100%', background:'#eee', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', color:'#888'}}>
         <CarIcon />
         <span style={{fontSize:'12px', fontWeight:600, marginTop:'5px'}}>Preview Unavailable</span>
      </div>
    );
  }

  // Render container. It will be gray/loading until the API snaps into place.
  return <div style={{ width: '100%', height: '100%', background: '#eee', pointerEvents: 'none' }} ref={ref} />;
};

const ListingDetailModal: React.FC<DetailProps> = ({ listing, onClose, viewMode }) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  
  if (!listing) return null;

  // Select Data Source based on View Mode
  const isInvestor = viewMode === 'Investor';
  const sourceMap = isInvestor ? INVESTOR_DATA_MAP : BUYER_DATA_MAP;
  
  const data = sourceMap[listing.id] || {
    overview: "No detailed data available.", impacts: [], facts: {}, timeline: []
  };

  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const badgeColorClass = getBadgeClass(listing.pinColor);
  const headerStatusText = listing.devStatus || listing.badge; 

  // --- Dynamic Mini Map Config ---
  const getMapConfig = (pinColor: string) => {
    switch(pinColor) {
      case 'red': return { color: '#D32F2F', radius: 450, zoom: 14 }; // Type A: High Impact - Zoom reduced from 15 to 14
      case 'yellow': return { color: '#FBC02D', radius: 150, zoom: 16 }; // Type B: Medium Impact
      case 'green': return { color: '#388E3C', radius: 50, zoom: 18 }; // Type C: Active
      case 'blue': return { color: '#1976D2', radius: 25, zoom: 19 }; // Type D: Low Impact
      default: return { color: '#D32F2F', radius: 450, zoom: 14 }; // Default reduced to 14
    }
  };

  const mapConfig = getMapConfig(listing.pinColor || 'red');

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        
        {/* 1. STICKY HEADER */}
        <div className="modal-header">
          <div className="header-top">
            <div className="header-info">
              <h1>{listing.price}</h1>
              <div className="address">{listing.address}</div>
            </div>
            <div className="header-status">
              <span className={badgeColorClass}>{headerStatusText}</span>
              <button className="share-btn"><ShareIcon /></button>
              <button className="close-btn" onClick={onClose}><CloseIcon /></button>
            </div>
          </div>
          {/* Tabs */}
          <div className="modal-tabs">
            <button onClick={() => scrollToSection('overview')} className="tab-link">Overview</button>
            <button onClick={() => scrollToSection('impact')} className="tab-link">{isInvestor ? 'Investment Analysis' : 'Impact Analysis'}</button>
            <button onClick={() => scrollToSection('facts')} className="tab-link">Facts & Features</button>
            <button onClick={() => scrollToSection('timeline')} className="tab-link">Project History</button>
          </div>
        </div>

        {/* 2. SCROLLABLE BODY (IMAGES MOVED INSIDE) */}
        <div className="modal-body" ref={scrollRef}>
          
          {/* MEDIA ROW (NOW SCROLLS) */}
          <div className="media-row">
            <div className="media-item">
              <img src={listing.img} alt="Main" />
              <div className="media-label">Rendering</div>
            </div>
            <div className="media-item">
               {/* Mini Map with Impact Radius */}
               <Map
                  defaultCenter={{ lat: listing.lat, lng: listing.lng }}
                  defaultZoom={mapConfig.zoom}
                  mapTypeId={'satellite'}
                  disableDefaultUI={true}
                  gestureHandling={'none'}
                  style={{ width: '100%', height: '100%' }}
                >
                  <Marker position={{ lat: listing.lat, lng: listing.lng }} />
                  <MiniMapCircle center={{ lat: listing.lat, lng: listing.lng }} radius={mapConfig.radius} color={mapConfig.color} />
                </Map>
                <div className="media-label">Location</div>
            </div>
            <div className="media-item">
               {/* Use the Interactive Component, wrapped to look static, with fallback logic */}
               <StreetViewThumbnail position={{ lat: listing.lat, lng: listing.lng }} />
               <div className="media-label">Street View</div>
            </div>
          </div>

          <div className="content-wrapper">
            {/* A: Overview */}
            <div id="overview" className="detail-section">
              <div className="section-title">Overview</div>
              <p className="overview-text">{data.overview}</p>
            </div>
            
            {/* INSERTED INVESTMENT SIGNAL BAR ABOVE ANALYSIS */}
            {isInvestor && data.signal && (
              <div className="investment-signal-bar">
                📈 INVESTMENT SIGNAL: {data.signal}
              </div>
            )}

            {/* B: Impact/Investment Analysis */}
            <div id="impact" className="detail-section">
              <div className="section-title">{isInvestor ? 'Investment Analysis' : 'Impact Analysis'}</div>
              {data.impacts.length > 0 ? (
                <div className="impact-grid">
                  {data.impacts.map((imp, idx) => (
                    <div key={idx} className="risk-card">
                      <div className="risk-header">
                        {getIcon(imp.icon)}
                        <span>{imp.title}</span>
                        <span className={getLevelClass(imp.level)}>{imp.level}</span>
                      </div>
                      <div className="risk-desc">{imp.desc}</div>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="overview-text">No significant data reported.</p>
              )}
            </div>

            {/* C: Facts & Features */}
            <div id="facts" className="detail-section">
              <div className="section-title">Facts & Features</div>
              <div className="facts-grid">
                {Object.entries(data.facts).map(([key, value]) => (
                  <div key={key} className="fact-row">
                    <span className="fact-label">{key}</span>
                    <span className="fact-value">{value}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* D: Project History */}
            <div id="timeline" className="detail-section">
              <div className="section-title">Project History</div>
              <div className="timeline-list">
                {data.timeline.map((event, idx) => (
                  <div key={idx} className={`timeline-item ${event.active ? 'active' : ''}`}>
                    <div className="timeline-dot"></div>
                    <div className="timeline-date">{event.date}</div>
                    <div className="timeline-event">{event.title}</div>
                    {event.active && <div className="timeline-sub">Current Status</div>}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* 4. FLOATING FOOTER */}
        <div className="modal-footer">
           <button className="footer-btn-primary">
             {isInvestor ? 'Join Capital Waitlist' : 'Track This Project'}
           </button>
        </div>

      </div>
    </div>
  );
};

export default ListingDetailModal;